import { combineReducers } from "redux";

import { createPersistedReducer } from "../../utils/createPersistedReducer";
import { createReducer } from "../../utils/createReducer";
import {
  userLoginRoutine,
  userRoutine,
  userRegisterRoutine,
  userStatusRoutine,
  userUpdateRoutine,
  userChangePasswordRoutine,
  userPincodeRoutine,
  userPincodeLoginRoutine,
  userForgotRoutine,
  userSearchRoutine,
  usersGetRoutine,
  userRoleStatusRoutine,
} from "../routines/userRoutine";
import { tokenRoutine } from "../routines/tokenRoutine";

const persistConfig = {
  key: "user",
  whitelist: ["auth", "user", "userPincode"],
};

export default createPersistedReducer(
  combineReducers({
    user: createReducer(userRoutine, "user", true),
    auth: createReducer(tokenRoutine, "auth", true),
    userPincode: createReducer(userPincodeRoutine, "userPincode", true),
    userPincodeLogin: createReducer(userPincodeLoginRoutine),
    userLogin: createReducer(userLoginRoutine),
    userRegister: createReducer(userRegisterRoutine),
    userChangePassword: createReducer(userChangePasswordRoutine),
    userUpdate: createReducer(userUpdateRoutine),
    userForgot: createReducer(userForgotRoutine),
    userStatus: createReducer(userStatusRoutine),
    userSearch: createReducer(userSearchRoutine),
    usersGet: createReducer(usersGetRoutine),
    userRoleStatus: createReducer(userRoleStatusRoutine),
  }),
  persistConfig
);
